module.exports = __webpack_public_path__ + "img/dollar-white.953e2ee5.svg";